import React from "react";

function HelpPage() {
  return (
    <>
      <div style={{ width: "100%", height: "86vh" }}>
        <iframe
          src="https://stratus.gitbook.io/stratus/"
          width="100%"
          height="100%"
          title="Help"
          allowFullScreen
          style={{ border: "none", borderRadius: "7px" }}
        />
      </div>
    </>
  );
}

export default HelpPage;
